import React from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';
import classNames from 'classnames';

import Header from 'components/organisms/app/header';
import Footer from 'components/organisms/app/footer';
import MobileMenu from 'data/containers/mobileMenu';

import Home from 'components/templates/home';
import Profile from 'data/containers/profilePage';
import ProjectPage from 'components/templates/projectPage';
import Notfound from 'components/templates/notfound';

import PageTransition from './transitions';
import './styles.css';

const App = ({ location }) => {
    const locationKey = location.pathname.split('/')[1] || '/';

    // The shortcomings of not using CSS in JS... hooks for CSS
    let appClassName = classNames({
        'theme-project': locationKey === 'project',
        'theme-profile': locationKey === 'profile'
    });
    document.documentElement.className = appClassName;

    return (
        <div className="App">
            <section className="App__header">
                <Header />
            </section>
            <TransitionGroup className="App__body" component="section">
                <PageTransition key={locationKey} appear>
                    <div className="App__body__page">
                        <Switch location={location}>
                            <Route exact path="/" component={Home} />
                            <Route
                                exact
                                path={`/filter/:id`}
                                component={Home}
                            />
                            <Route
                                exact
                                path={`/project/:id`}
                                component={ProjectPage}
                            />
                            <Route exact path="/profile" component={Profile} />
                            <Route component={Notfound} />
                        </Switch>
                    </div>
                </PageTransition>
            </TransitionGroup>
            <section className="App__mobileMenu">
                <MobileMenu />
            </section>
            <section className="App__footer">
                <Footer />
            </section>
        </div>
    );
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/templates/app/index.js